import React from 'react'

const ViewParentsTitleContainer = ({featureImageUrl, title, isPlaceholderImage}:{featureImageUrl:string, title:string, isPlaceholderImage?: boolean}) => {
    return (<div className='view-parents-title-container'>
        <img className={`parent-feature-image ${isPlaceholderImage ? 'placeholder' : ''}`} src={featureImageUrl} alt='' />
        <span>{title}</span>
    </div>)
}

export default ViewParentsTitleContainer